import { Dispatch, SetStateAction } from "react";
import { BBActivityShop } from "../bblanding/BBActivityComp";
import { ACTIVITY_CHOICES } from "./BBEnum";
import { IProduct } from "../../interfaces/IProducts";
import BBHelperClass from "../../classes/BBHelperClass";
import HelperClass from "../../classes/HelperClass";
// import { IBBActivity } from "../../interfaces/IBB";

export interface IBBActivitiesJSX {
    activityId: number; //productId
    setActivityId: Dispatch<SetStateAction<number>>;
    products?: IProduct[];
}

/* ------------------------------------------------ 
 * 
   ------------------------------------------------ */
const BBActivities = (props: IBBActivitiesJSX) => {
    /* ----------------------------------------------------- */
    function showActivity(activityType: ACTIVITY_CHOICES) {
        let activityObj = BBHelperClass.getProductFromInStoreByVariant(activityType, props.products);
        if (activityObj != undefined) {
            return (
                <div className="column">
                    <div className={"card " + (HelperClass.isProductInStore(props.activityId, activityObj.inStore) && "has-background-info-light")}>
                        <a onClick={() => props.setActivityId(HelperClass.getFirstProductIdInStore(activityObj?.inStore))}>
                            <div className="card-content pb-1">
                                <BBActivityShop activityType={activityType} bbActivity={activityObj} />
                            </div>
                        </a>
                        <div className="pl-4 pb-1">
                            <a href="">więcej informacji</a>
                        </div>
                    </div>
                </div>
            );
        }
        return <></>;
    }
    return (
        <div className="columns">
            {showActivity(ACTIVITY_CHOICES.ACTIVITY_WALK)}
            {showActivity(ACTIVITY_CHOICES.ACTIVITY_RUN)}
            {showActivity(ACTIVITY_CHOICES.ACTIVITY_RIDE)}
            {showActivity(ACTIVITY_CHOICES.ACTIVITY_IRON)}
        </div>
    );
};

export default BBActivities;
